import React, { useState } from "react";
import Table, { CellTmpl, DEFAULT_PAYLOAD, reactFormatter } from "../../../common/Table";
import LawDetails from "./LawDetails";
import AddEditLaw from "./AddEditLaw";
import { useDeleteLaw, useGetLaws } from "../../../../backend/masters";
import { useExportLaws } from "../../../../backend/exports";
import { GetMastersBreadcrumb } from "../Master.constants";
import BaseList from '../../../common/BaseList';
import { LawSchema } from '../../../../models/law';

function Law() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('Law'));

    const columns = [
        { title: "Name", field: "name", formatter: reactFormatter(<CellTmpl />) },
        { title: "Description", field: "description", widthGrow: 2, formatter: reactFormatter(<CellTmpl />) }
    ]

    return (
        <BaseList
          fetchData={useGetLaws}
          exportData={useExportLaws}
          deleteData={useDeleteLaw}
          nameAttribute={'name'}
          columns={columns}
          DetailView={LawDetails}
          FormView={AddEditLaw}
          modelSchema={LawSchema}
          initialSort={['name asc']}
          breadcrumb={breadcrumb}
          title="Mastsers - Laws"
        />
    )
}

export default Law;
